export const UOBDisabledAccessList = ["Manage Bill Payments", "Request Reimbursement", "Submit Bills"];
